import axios from 'axios'

export const mutations = {
  orderRefresh (state, orders) {
    state.all = orders
    console.log('refresh orders')
  },
  orderExtend (state, order) {
    console.log('extend order')
    state.creating = order // only to show order number to user after placing order
    state.all.push(order)
  },
  orderCreate (state) {
    console.log('create order')
    state.creating = { // default value
      'orderId': '', // assigned in DB
      'address': '',
      'customer': '',
      'customerId': '',
      'name': '',
      'email': '',
      'userId': '',
      'date': '',
      'dateRaw': '',
      'products': [],
      'totalPrice': 0,
      'totalItems': 0,
      'status': 'pending',
      'note': ''
    }
  },
  orderCancelCreate (state) {
    console.log('cancel create order')
    state.creating = undefined
  },
  orderUpdateOne (state, updated) {
    console.log('update one order')
    if (state.all.length === 0) {
      state.all.push(updated)
    } else {
      state.all = state.all.map(order => {
        return order._id === updated._id ? updated : order
      })
    }
  },
  orderError (state) {
    state.error = true
  },
  orderCancelError (state) {
    state.error = false
  }
}

export const actions = {
  // ========================================
  fetchOrders: async ({ commit }) => {
    try {
      let orders = await axios.get('/api/v1/orders')
      commit('orderRefresh', orders.data)
    } catch (err) {
      commit('orderRefresh', [])
    }
  },
  // ========================================
  fetchAllOrdersOfUser: async ({ commit, state }, userEmail) => {
    try {
      console.log('run fetchAllOrdersOfUser')
      let orders = await axios.get('/api/v1/orders/' + userEmail)
      commit('orderRefresh', orders.data)
    } catch (err) {
      console.log(err)
    }
  },
  // ========================================
  saveOrder: async ({ commit, state }) => {
    try {
      console.log('run saveOrder')
      let response = await axios.post('/api/v1/orders', state.creating)
      commit('orderExtend', response.data) // insert a new order also with its _ID
    } catch (err) {
      commit('orderError')
      console.log(err)
    }
  }
}

export const getters = {
  allOrders: (state) => {
    return state.all
  },
  creatingOrder: (state) => {
    return state.creating
  },
  orderError: (state) => {
    return state.error
  }
}

export default {
  state: {
    all: [],
    creating: undefined,
    error: false
  },
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/Orders.js